const actions = {
  GET_DRIVERS_REQUEST: "GET_DRIVERS_REQUEST",
  GET_DRIVERS_SUCCESS: "GET_DRIVERS_SUCCESS",
  GET_ORDERS_INFO_REQUEST: "GET_ORDERS_INFO_REQUEST",
  GET_ORDERS_INFO_SUCCESS: "GET_ORDERS_INFO_SUCCESS",

  getDrivers: (restaurantId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_DRIVERS_REQUEST,
        restaurantId,
      });
    };
  },

  getOrderInfoByDrivers: (
    driversIds,
    startDate,
    endDate,
    selectedRestaurant
  ) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ORDERS_INFO_REQUEST,
        driversIds,
        startDate,
        endDate,
        selectedRestaurant,
      });
    };
  },
};

export default actions;
